<template>
  <div class="basket-summary mt-auto w-100 py-2 px-1">
    <div class="container">
      <div class="row mb-2">
        <div class="col-12">
          <basket-coupon></basket-coupon>
        </div>
      </div>
      <div class="row">
        <div class="col order-1 text-right">
          <basket-totals no-delivery></basket-totals>
        </div>
        </div>
        <div class="row mt-2">
        <div
          class="col-6 text-left align-self-center"
          v-if="!isCheckout"
        >
          <b-button
            href="/checkout/order-summary"
            variant="link"
            v-if="!user.is_guest"
            :disabled="Object.keys(basket.items).length < 1"
          >
            Express Checkout</b-button
          >
          
        </div>
        <div
          class="col-6 text-right align-self-center"
          v-if="!isCheckout"
        >
          <b-button
            :href="wpConfig.checkout_url"
            variant="success"
            :disabled="Object.keys(basket.items).length < 1"
            class="btn-rounded"
          >
            <svg class="bi mr-1" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#check2"
              /></svg
            >Checkout</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasketCoupon from "@/components/BasketCoupon";
import BasketTotals from "@/components/BasketTotals";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BasketCoupon,
    BasketTotals,
  },
  computed: {
    ...mapGetters("readiness", ["is_ready"]),
    basket() {
      return this.$store.state.basket;
    },
    user() {
      return this.$store.state.user;
    },
  },
};
</script>